import { render } from "./FollowUpStatementSelector.vue?vue&type=template&id=584b0310&scoped=true"
import script from "./FollowUpStatementSelector.vue?vue&type=script&lang=js"
export * from "./FollowUpStatementSelector.vue?vue&type=script&lang=js"

import "./FollowUpStatementSelector.vue?vue&type=style&index=0&id=584b0310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-584b0310"]])

export default __exports__